export class CheckUploadFiles {

  constructor() {
    const elements = this.getElements()
    if (!elements) return

    this.registerEventListener()
  }

  getElements() {
    this.inputFile = document.querySelector('[data-contact-form] input[type=file]');
    this.inputFile = document.querySelector('[data-contact-form] input[type=file]');
    this.uploadInfo = document.querySelector('[data-contact-form] .contact-form__handle-info');
    this.resume = document.querySelector('[data-contact-form] .contact-form__resume');

    if (!this.inputFile || !this.uploadInfo || !this.resume) return false

    return true
  }

  registerEventListener() {
    this.inputFile.addEventListener('change', (event) => this.checkSize(event))
  }

  checkSize() {
    const fileList = event.target.files;

    if (fileList.length == 0) return

    this.showMesssage(fileList[0])
    const deleteFileBtn = document.querySelector('[data-contact-form] .del_form');
    console.log(deleteFileBtn)
    deleteFileBtn.addEventListener('click', this.deleteFile.bind(this))
  }

  deleteFile() {
    console.log('dupa')
    this.inputFile.value = '';
    this.uploadInfo.innerHTML = '';
    this.resume.innerHTML = '<label class="contact-form__file" for="upload-file">Upload resume</label></br><small>(only .pdf, max 2Mb)</small>';
  }

  showMesssage(file) {
    if (file.size > 2048000) {
      this.resume.innerHTML = `<img class="pr-2" src="/app/themes/movecloser/dist/images/file.svg"/> <div class="text-container">${file.name}</div> <a class="del_form">Delete</a>`;
      this.uploadInfo.innerHTML = `<font color="red">File ${file.name} is too large.</font>`;
      this.inputFile.value = null;
      return false;
    }
    if (file.size < 2048000) {
      this.resume.innerHTML = '';
      this.uploadInfo.innerHTML = `<img class="pr-2" src="/app/themes/movecloser/dist/images/file.svg"/> <div class="text-container">${file.name}</div> <a class="del_form">Delete</a>`;
    }
  }
}
